<app-base-modal
  [title]="getTitleModal()"
  [showStateToggle]="isValid"
>
  <div class="wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (turnkeyCost of turnkeyCostsData; track $index) {
        <mat-expansion-panel [expanded]="turnkeyCost.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-turnkey-cost-accordion-header
                class="turnkey-cost-accordion-header"
                [turnkeyCost]="turnkeyCost"
                [isEditModeActive]="isEditModeActive"
                (handleDeleteTurnkeyCost)="removeTurnkeyCostAtIndex($index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-turnkey-cost-form
            [parentId]="turnkeyCostDialogData.parentId"
            [turnkeyCostFormGroup]="turnkeyCostFormGroups[$index]"
            [turnkeyCostData]="turnkeyCost"
            [noFirstData]="noFirstData"
            [isEditModeActive]="isEditModeActive"
            (updateTurnkeyCostData)="updateTurnkeyCostData($event, $index)"
            (deleteTurnkeyCost)="deleteTurnkeyCost($index)"
          />
          @if (turnkeyCost.id) {
            <div
              class="turnkey-cost-files"
              app-turnkey-cost-files
              [turnkeyCostId]="turnkeyCost.id"
              [turnkeyCostKey]="turnkeyCostDialogData.modalKey"
              [isEditModeActive]="isEditModeActive"
              (setLoadingState)="setLoadingState($event)"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      Добавить новую
    </button>
  </div>
</app-base-modal>
